import { ProviderSRL as ProviderResponse } from '@/DTOS/Provider/ProviderSRL';
import { Button, Tag, Tooltip } from 'antd';
import React from 'react';
import { EditOutlined} from '@ant-design/icons';

export const ProviderColumn = (handleEdit: (record: ProviderResponse) => void) => [
  
  {
    title: 'Furnizor Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Tip de client',
    dataIndex: 'type',
    key: 'type',
    width: 150,
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'Grup',
    dataIndex: 'providerGroup',
    key: 'providerGroup',
    width: 150,
    render: (record: { name: any }) => (
      <Tooltip title={record ? record?.name : '-'}>
        <div className="ellipsis-cell">{record ? record?.name : '-'}</div>
      </Tooltip>
    )
  },
  {
    title: 'Denunmire',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'Administrator',
    dataIndex: 'leadership',
    key: 'leadership',
    width: 150,
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'Adresa',
    dataIndex: 'address',
    key: 'address',
    width: 150,
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'CNP',
    dataIndex: 'cnp',
    key: 'cnp',
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
  },
  {
    title: 'CUI',
    dataIndex: 'cui',
    key: 'cui',
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Banca',
    dataIndex: 'bank',
    key: 'bank',
    width: 150,render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )

  },
  {
    title: 'IBAN',
    dataIndex: 'bankAccount',
    key: 'bankAccount',
    width: 150,
    render: (text: string) => (
          <Tooltip title={text}>
            <div className="ellipsis-cell">{text}</div>
          </Tooltip>
        )
  },
  {
    title: 'Numar inregistrare',
    dataIndex: 'registrationNumber',
    key: 'registrationNumber',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Descrierea activitatii',
    dataIndex: 'activityDescription',
    key: 'activityDescription',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Telefon',
    dataIndex: 'phone',
    key: 'phone',
    width: 150,
    render: (_: any, record: any) => (
      <div className='phone-column'>
        {record?.phone?.map((item: any, index: any) => (
          <Tag color={'blue'} key={`phone_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.phone && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
    render: (_: any, record: any) => (
      <div className='email-column'>
        {record?.email?.map((item: any, index: any) => (
          <Tag color={'blue'} key={`email_${index}`}>
            {item}
          </Tag>
        ))}
        {!record?.email && <Tag color={'blue'}>-</Tag>}
      </div>
    ),
  },
  {
    title: 'Adresa web',
    dataIndex: 'webAddress',
    key: 'webAddress',
    width: 150,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className="ellipsis-cell">{record ? record : "-"}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: ProviderResponse) => 
    <Tooltip title='Modifica'>
    <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
    </Tooltip>,
    width: 120,
    fixed:'right',
  },
];
